import { HoverCardWithIcon } from '@/common/components/shared/hover-card/HoverCardWithIcon';

export const TooltipDottedLineManager = () => (
  <HoverCardWithIcon position="top">
    A &ldquo;Dotted Line Manager&rdquo; is a secondary supervisor who provides guidance to an employee but isn&apos;t
    his/her primary manager.
  </HoverCardWithIcon>
);
